import axios from 'axios';

const getSignedURL = async (fileName) => {
    const response = await axios.get(
        `${process.env.REACT_APP_API_BASE}/get-url?folder=${fileName}`
    );
    return response.data;
};

export default getSignedURL;
